import React, { useEffect, useState } from 'react';

import { FILTER_GLOBAL_KEYS, FILTER_KEYS, LEAGUE, LEAGUES, SCOPE } from '../../config/constants';
import { Dropdown } from 'react-bootstrap';
import { useFiltersDispatch, useFiltersState } from 'store/hooks';
import { useRouter } from 'helpers/customHooks';
import { getVenues, text_truncate } from 'helpers';



const FiltersEntitiesPage =  ({ loadData, showMessg, specificScope }: {loadData: () => void, showMessg:boolean, specificScope:string} ) => {
  const [showFilter, setShowFilter] = useState(false);
  const close = () => setShowFilter(false);
  const open = () => setShowFilter(true);
  const { [FILTER_KEYS.LEAGUE]: league = LEAGUE.types[LEAGUE.defaultIndex], [FILTER_GLOBAL_KEYS.VENUES]: venues, [FILTER_KEYS.VENUE]: filterData, } = useFiltersState(specificScope, FILTER_KEYS.LEAGUE,
    FILTER_GLOBAL_KEYS.VENUES, FILTER_KEYS.VENUE);
  const [optionSelected, setOptionSelected] = useState(league);
  const [optionSelectedVenue, setOptionSelectedVenue] = useState(filterData);
  const [appliqued, setAppliqued] = useState(false);
  const { loadTeams, changeFilterData } = useFiltersDispatch();
  const { types, title } = LEAGUE;
  const typeFilter = getVenues(venues, optionSelected.value.value, optionSelected.value.type);
  const groupFilter:any[] = [];

  useEffect(() => {
    if(showMessg){
      setOptionSelected({name: '', value: {label:'', value: '', type: ''}});
      setOptionSelectedVenue(undefined);
    }
  
  }, [showMessg]);

  useEffect(() => {
      setOptionSelectedVenue(undefined);
  }, [league]);

  typeFilter.map((venue)=>{
    if(venue.siteName.includes('Group') || venue.siteName.includes('Gorup')){
      groupFilter.push(venue);
    } 
  });
  let filterTypeFilter = typeFilter.filter(function(venue){
    if(!venue.siteName.includes('Group')){
      return venue;
    }
  });

  filterTypeFilter = filterTypeFilter.filter(function(venue){
    if(!venue.siteName.includes('Gorup')){
      return venue;
    }
  });
  let venueList = filterTypeFilter.map((venue) => ({
    value: venue,
    name: venue.label ? venue.label : `${venue.siteName} (${venue.teamId ? venue.teamId : '-'}) `
  }));
  const groupList = groupFilter.map((venue) => ({
    value: venue,
    name: venue.label ? venue.label : `${venue.siteName} (${venue.teamId ? venue.teamId : '-'}) `
  }));
  venueList.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  groupList.sort(function (a, b) {
    return a.value.siteId.localeCompare(b.value.siteId);
  });
 venueList = venueList.concat(groupList);

  const li: JSX.Element[] = [];
  types.forEach((type) => {
    li.push(
      <li
        key={JSON.stringify(type)}
        className="li-simple-selector"
      >
        <div className="radio" style={{ fontSize: '12px' }}>
          <input
            id={'radio-' + JSON.stringify(type)}
            name={`radio-${type.name}`}
            type="radio"
            checked={JSON.stringify(optionSelected) === JSON.stringify(type)}
            onChange={() => {setOptionSelected(type);
                setAppliqued(true);
                changeFilterData(type, FILTER_KEYS.LEAGUE)();
                changeFilterData({name: '', value: {label:'', value: '', type: ''}}, FILTER_KEYS.VENUE)();               
            }}
          />
          <label
            htmlFor={'radio-' + JSON.stringify(type)}
            style={{ fontWeight: JSON.stringify(optionSelected) === JSON.stringify(type) ? 'bold' : undefined }}
            className="radio-label"
          >
            {type.name}
          </label>
        </div>
      </li>)
    ;
  });

  const liVenues: JSX.Element[] = [];
  venueList.forEach((type) => {
    liVenues.push(
      <li
        key={JSON.stringify(type)}
        className="li-simple-selector"
      >
        <div className="radio" style={{ fontSize: '12px' }}>
          <input
            id={'radio-' + JSON.stringify(type)}
            name={`radio-${type.name}`}
            type="radio"
            checked={JSON.stringify(optionSelectedVenue) === JSON.stringify(type)}
            onChange={() => {setOptionSelectedVenue(type);
                close();
                setAppliqued(true);
                changeFilterData(type, FILTER_KEYS.VENUE)();
            }}
          />
          <label
            htmlFor={'radio-' + JSON.stringify(type)}
            style={{ fontWeight: JSON.stringify(optionSelected) === JSON.stringify(type) ? 'bold' : undefined }}
            className="radio-label"
          >
            {type.name}
          </label>
        </div>
      </li>)
    ;
  });
  
  return (
    <Dropdown className="dropdown-date-compare" show={showFilter} onToggle={showFilter ? close : open}>
      <Dropdown.Toggle
        id="dropdown-date-compare"
        className="btn-border"
        style={{ width: '195px' }}
      >
        <label className={'appliqued'}>
        LEAGUE TEAM
        </label>
        { showMessg? 'Select' : text_truncate(optionSelected.name,15)+`/${ league.value.value === LEAGUES.MLAX? text_truncate(optionSelectedVenue?.name,9):
          text_truncate(optionSelectedVenue?.name,12)}`}
      </Dropdown.Toggle>
      <Dropdown.Menu
      className="simple-selector-dropdown-menu"
      >
        <div className={'season-week-container'}>
          <div className="season-week-body">
            <div className="season-week-column year column-border-right">
              <div className="head-title-column column-border-bottom">
                LEAGUE
              </div>
              
              <ul className="ul-simple-selector scroll-style-zebra-sports">
                {li}
              </ul>
              
            </div>
            <div className="season-week-column off-season" style={league.value.label === 'NFL Game' ? {width:'280px'}:{width:'196px'}}>
            <div className="head-title-column column-border-bottom">
              TEAM
              </div>
              
              <ul className="ul-simple-selector scroll-style-zebra-sports">
                {liVenues}
              </ul>
              
              </div>
              </div>
              
              </div>
      </Dropdown.Menu>
    </Dropdown>
);
};
export default FiltersEntitiesPage;